/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_To_All_HelpInputs */

const en_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto format all events in the selected event group.`)
};

const fr_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-formater tous les événements du groupe sélectionné.`)
};

const de_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Ereignisse in der ausgewählten Ereignisgruppe automatisch formatieren.`)
};

const it_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatta automaticamente tutti gli eventi nel gruppo di eventi selezionato.`)
};

const ru_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование всех событий в выбранной группе событий.`)
};

const es_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatear automáticamente todos los eventos en el grupo de eventos seleccionado.`)
};

const zh_cn2_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化所选事件组中的所有事件。`)
};

const ja_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベント グループ内のすべてのイベントを自動フォーマットします。`)
};

const hi_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह में सभी इवेंट्स को स्वचालित रूप से फॉर्मेट करें।`)
};

const pt_pt2_apply_to_all_help = /** @type {(inputs: Apply_To_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatar automaticamente todos os eventos no grupo de eventos selecionado.`)
};

/**
* | output |
* | --- |
* | "Auto format all events in the selected event group." |
*
* @param {Apply_To_All_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to_all_help = /** @type {((inputs?: Apply_To_All_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_To_All_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_to_all_help(inputs)
	if (locale === "de") return de_apply_to_all_help(inputs)
	if (locale === "it") return it_apply_to_all_help(inputs)
	if (locale === "ru") return ru_apply_to_all_help(inputs)
	if (locale === "es") return es_apply_to_all_help(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_to_all_help(inputs)
	if (locale === "ja") return ja_apply_to_all_help(inputs)
	if (locale === "hi") return hi_apply_to_all_help(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_to_all_help(inputs)
	return en_apply_to_all_help(inputs)
});